/* === Rashi Calculator (Vedic / Moon-based) ===
   Generado a partir del HTML del cliente (nimmisha_vedic_calculator v6) + integración del tema:
   - Klaviyo real (W5fsk9 / Rubpjt), opt-in explícito RGPD (newsletter al final, opcional).
   - IDs prefijados rashi- (evita colisiones en el storefront).
   - Imágenes reales de producto (fetch) y fotos de piedra (window.RASHI_ICONS.stones).
   - Modal abrir/cerrar. Datos astronómicos (CITIES, RASHIS, toJD, moonLongitude) copiados verbatim. */
(function () {
  'use strict';

  // ── Klaviyo (claves del cliente) ──
  var KLAVIYO_ENABLED = true;
  var KLAVIYO_PUBLIC_KEY = 'W5fsk9';
  var KLAVIYO_LIST_ID = 'Rubpjt';

  const CITIES = [
    { city: 'London', country: 'UK', tz: 'Europe/London' },
    { city: 'Birmingham', country: 'UK', tz: 'Europe/London' },
    { city: 'Manchester', country: 'UK', tz: 'Europe/London' },
    { city: 'Glasgow', country: 'UK', tz: 'Europe/London' },
    { city: 'Leeds', country: 'UK', tz: 'Europe/London' },
    { city: 'Liverpool', country: 'UK', tz: 'Europe/London' },
    { city: 'Edinburgh', country: 'UK', tz: 'Europe/London' },
    { city: 'Bristol', country: 'UK', tz: 'Europe/London' },
    { city: 'Cardiff', country: 'UK', tz: 'Europe/London' },
    { city: 'Belfast', country: 'UK', tz: 'Europe/London' },
    { city: 'Dublin', country: 'Ireland', tz: 'Europe/Dublin' },
    { city: 'Cork', country: 'Ireland', tz: 'Europe/Dublin' },
    { city: 'Limerick', country: 'Ireland', tz: 'Europe/Dublin' },
    { city: 'Paris', country: 'France', tz: 'Europe/Paris' },
    { city: 'Marseille', country: 'France', tz: 'Europe/Paris' },
    { city: 'Lyon', country: 'France', tz: 'Europe/Paris' },
    { city: 'Toulouse', country: 'France', tz: 'Europe/Paris' },
    { city: 'Nice', country: 'France', tz: 'Europe/Paris' },
    { city: 'Berlin', country: 'Germany', tz: 'Europe/Berlin' },
    { city: 'Hamburg', country: 'Germany', tz: 'Europe/Berlin' },
    { city: 'Munich', country: 'Germany', tz: 'Europe/Berlin' },
    { city: 'Cologne', country: 'Germany', tz: 'Europe/Berlin' },
    { city: 'Frankfurt', country: 'Germany', tz: 'Europe/Berlin' },
    { city: 'Madrid', country: 'Spain', tz: 'Europe/Madrid' },
    { city: 'Barcelona', country: 'Spain', tz: 'Europe/Madrid' },
    { city: 'Valencia', country: 'Spain', tz: 'Europe/Madrid' },
    { city: 'Seville', country: 'Spain', tz: 'Europe/Madrid' },
    { city: 'Rome', country: 'Italy', tz: 'Europe/Rome' },
    { city: 'Milan', country: 'Italy', tz: 'Europe/Rome' },
    { city: 'Naples', country: 'Italy', tz: 'Europe/Rome' },
    { city: 'Turin', country: 'Italy', tz: 'Europe/Rome' },
    { city: 'Lisbon', country: 'Portugal', tz: 'Europe/Lisbon' },
    { city: 'Porto', country: 'Portugal', tz: 'Europe/Lisbon' },
    { city: 'Braga', country: 'Portugal', tz: 'Europe/Lisbon' },
    { city: 'Amsterdam', country: 'Netherlands', tz: 'Europe/Amsterdam' },
    { city: 'Rotterdam', country: 'Netherlands', tz: 'Europe/Amsterdam' },
    { city: 'The Hague', country: 'Netherlands', tz: 'Europe/Amsterdam' },
    { city: 'Brussels', country: 'Belgium', tz: 'Europe/Brussels' },
    { city: 'Antwerp', country: 'Belgium', tz: 'Europe/Brussels' },
    { city: 'Ghent', country: 'Belgium', tz: 'Europe/Brussels' },
    { city: 'Bern', country: 'Switzerland', tz: 'Europe/Zurich' },
    { city: 'Zurich', country: 'Switzerland', tz: 'Europe/Zurich' },
    { city: 'Geneva', country: 'Switzerland', tz: 'Europe/Zurich' },
    { city: 'Basel', country: 'Switzerland', tz: 'Europe/Zurich' },
    { city: 'Vienna', country: 'Austria', tz: 'Europe/Vienna' },
    { city: 'Graz', country: 'Austria', tz: 'Europe/Vienna' },
    { city: 'Linz', country: 'Austria', tz: 'Europe/Vienna' },
    { city: 'Stockholm', country: 'Sweden', tz: 'Europe/Stockholm' },
    { city: 'Gothenburg', country: 'Sweden', tz: 'Europe/Stockholm' },
    { city: 'Malmo', country: 'Sweden', tz: 'Europe/Stockholm' },
    { city: 'Oslo', country: 'Norway', tz: 'Europe/Oslo' },
    { city: 'Bergen', country: 'Norway', tz: 'Europe/Oslo' },
    { city: 'Trondheim', country: 'Norway', tz: 'Europe/Oslo' },
    { city: 'Copenhagen', country: 'Denmark', tz: 'Europe/Copenhagen' },
    { city: 'Aarhus', country: 'Denmark', tz: 'Europe/Copenhagen' },
    { city: 'Odense', country: 'Denmark', tz: 'Europe/Copenhagen' },
    { city: 'Helsinki', country: 'Finland', tz: 'Europe/Helsinki' },
    { city: 'Espoo', country: 'Finland', tz: 'Europe/Helsinki' },
    { city: 'Tampere', country: 'Finland', tz: 'Europe/Helsinki' },
    { city: 'Reykjavik', country: 'Iceland', tz: 'Atlantic/Reykjavik' },
    { city: 'Warsaw', country: 'Poland', tz: 'Europe/Warsaw' },
    { city: 'Krakow', country: 'Poland', tz: 'Europe/Warsaw' },
    { city: 'Lodz', country: 'Poland', tz: 'Europe/Warsaw' },
    { city: 'Wroclaw', country: 'Poland', tz: 'Europe/Warsaw' },
    { city: 'Prague', country: 'Czech Republic', tz: 'Europe/Prague' },
    { city: 'Brno', country: 'Czech Republic', tz: 'Europe/Prague' },
    { city: 'Ostrava', country: 'Czech Republic', tz: 'Europe/Prague' },
    { city: 'Bratislava', country: 'Slovakia', tz: 'Europe/Bratislava' },
    { city: 'Kosice', country: 'Slovakia', tz: 'Europe/Bratislava' },
    { city: 'Budapest', country: 'Hungary', tz: 'Europe/Budapest' },
    { city: 'Debrecen', country: 'Hungary', tz: 'Europe/Budapest' },
    { city: 'Szeged', country: 'Hungary', tz: 'Europe/Budapest' },
    { city: 'Bucharest', country: 'Romania', tz: 'Europe/Bucharest' },
    { city: 'Cluj-Napoca', country: 'Romania', tz: 'Europe/Bucharest' },
    { city: 'Timisoara', country: 'Romania', tz: 'Europe/Bucharest' },
    { city: 'Sofia', country: 'Bulgaria', tz: 'Europe/Sofia' },
    { city: 'Plovdiv', country: 'Bulgaria', tz: 'Europe/Sofia' },
    { city: 'Varna', country: 'Bulgaria', tz: 'Europe/Sofia' },
    { city: 'Athens', country: 'Greece', tz: 'Europe/Athens' },
    { city: 'Thessaloniki', country: 'Greece', tz: 'Europe/Athens' },
    { city: 'Patras', country: 'Greece', tz: 'Europe/Athens' },
    { city: 'Zagreb', country: 'Croatia', tz: 'Europe/Zagreb' },
    { city: 'Split', country: 'Croatia', tz: 'Europe/Zagreb' },
    { city: 'Rijeka', country: 'Croatia', tz: 'Europe/Zagreb' },
    { city: 'Belgrade', country: 'Serbia', tz: 'Europe/Belgrade' },
    { city: 'Novi Sad', country: 'Serbia', tz: 'Europe/Belgrade' },
    { city: 'Nis', country: 'Serbia', tz: 'Europe/Belgrade' },
    { city: 'Ljubljana', country: 'Slovenia', tz: 'Europe/Ljubljana' },
    { city: 'Maribor', country: 'Slovenia', tz: 'Europe/Ljubljana' },
    { city: 'Sarajevo', country: 'Bosnia and Herzegovina', tz: 'Europe/Sarajevo' },
    { city: 'Banja Luka', country: 'Bosnia and Herzegovina', tz: 'Europe/Sarajevo' },
    { city: 'Skopje', country: 'North Macedonia', tz: 'Europe/Skopje' },
    { city: 'Tirana', country: 'Albania', tz: 'Europe/Tirane' },
    { city: 'Durres', country: 'Albania', tz: 'Europe/Tirane' },
    { city: 'Podgorica', country: 'Montenegro', tz: 'Europe/Podgorica' },
    { city: 'Pristina', country: 'Kosovo', tz: 'Europe/Belgrade' },
    { city: 'Chisinau', country: 'Moldova', tz: 'Europe/Chisinau' },
    { city: 'Kyiv', country: 'Ukraine', tz: 'Europe/Kiev' },
    { city: 'Kharkiv', country: 'Ukraine', tz: 'Europe/Kiev' },
    { city: 'Odesa', country: 'Ukraine', tz: 'Europe/Kiev' },
    { city: 'Dnipro', country: 'Ukraine', tz: 'Europe/Kiev' },
    { city: 'Minsk', country: 'Belarus', tz: 'Europe/Minsk' },
    { city: 'Gomel', country: 'Belarus', tz: 'Europe/Minsk' },
    { city: 'Moscow', country: 'Russia', tz: 'Europe/Moscow' },
    { city: 'St Petersburg', country: 'Russia', tz: 'Europe/Moscow' },
    { city: 'Novosibirsk', country: 'Russia', tz: 'Asia/Novosibirsk' },
    { city: 'Yekaterinburg', country: 'Russia', tz: 'Asia/Yekaterinburg' },
    { city: 'Vilnius', country: 'Lithuania', tz: 'Europe/Vilnius' },
    { city: 'Kaunas', country: 'Lithuania', tz: 'Europe/Vilnius' },
    { city: 'Riga', country: 'Latvia', tz: 'Europe/Riga' },
    { city: 'Daugavpils', country: 'Latvia', tz: 'Europe/Riga' },
    { city: 'Tallinn', country: 'Estonia', tz: 'Europe/Tallinn' },
    { city: 'Tartu', country: 'Estonia', tz: 'Europe/Tallinn' },
    { city: 'Valletta', country: 'Malta', tz: 'Europe/Malta' },
    { city: 'Luxembourg', country: 'Luxembourg', tz: 'Europe/Luxembourg' },
    { city: 'Monaco', country: 'Monaco', tz: 'Europe/Monaco' },
    { city: 'Andorra la Vella', country: 'Andorra', tz: 'Europe/Andorra' },
    { city: 'San Marino', country: 'San Marino', tz: 'Europe/San_Marino' },
    { city: 'Vaduz', country: 'Liechtenstein', tz: 'Europe/Vaduz' },
    { city: 'Nicosia', country: 'Cyprus', tz: 'Asia/Nicosia' },
    { city: 'Limassol', country: 'Cyprus', tz: 'Asia/Nicosia' },
    { city: 'Istanbul', country: 'Turkey', tz: 'Europe/Istanbul' },
    { city: 'Ankara', country: 'Turkey', tz: 'Europe/Istanbul' },
    { city: 'Izmir', country: 'Turkey', tz: 'Europe/Istanbul' },
    { city: 'Bursa', country: 'Turkey', tz: 'Europe/Istanbul' },
    { city: 'Jerusalem', country: 'Israel', tz: 'Asia/Jerusalem' },
    { city: 'Tel Aviv', country: 'Israel', tz: 'Asia/Jerusalem' },
    { city: 'Haifa', country: 'Israel', tz: 'Asia/Jerusalem' },
    { city: 'Beirut', country: 'Lebanon', tz: 'Asia/Beirut' },
    { city: 'Tripoli', country: 'Lebanon', tz: 'Asia/Beirut' },
    { city: 'Amman', country: 'Jordan', tz: 'Asia/Amman' },
    { city: 'Zarqa', country: 'Jordan', tz: 'Asia/Amman' },
    { city: 'Irbid', country: 'Jordan', tz: 'Asia/Amman' },
    { city: 'Damascus', country: 'Syria', tz: 'Asia/Damascus' },
    { city: 'Aleppo', country: 'Syria', tz: 'Asia/Damascus' },
    { city: 'Baghdad', country: 'Iraq', tz: 'Asia/Baghdad' },
    { city: 'Basra', country: 'Iraq', tz: 'Asia/Baghdad' },
    { city: 'Mosul', country: 'Iraq', tz: 'Asia/Baghdad' },
    { city: 'Riyadh', country: 'Saudi Arabia', tz: 'Asia/Riyadh' },
    { city: 'Jeddah', country: 'Saudi Arabia', tz: 'Asia/Riyadh' },
    { city: 'Mecca', country: 'Saudi Arabia', tz: 'Asia/Riyadh' },
    { city: 'Medina', country: 'Saudi Arabia', tz: 'Asia/Riyadh' },
    { city: 'Abu Dhabi', country: 'UAE', tz: 'Asia/Dubai' },
    { city: 'Dubai', country: 'UAE', tz: 'Asia/Dubai' },
    { city: 'Sharjah', country: 'UAE', tz: 'Asia/Dubai' },
    { city: 'Doha', country: 'Qatar', tz: 'Asia/Qatar' },
    { city: 'Al Rayyan', country: 'Qatar', tz: 'Asia/Qatar' },
    { city: 'Kuwait City', country: 'Kuwait', tz: 'Asia/Kuwait' },
    { city: 'Al Ahmadi', country: 'Kuwait', tz: 'Asia/Kuwait' },
    { city: 'Manama', country: 'Bahrain', tz: 'Asia/Bahrain' },
    { city: 'Riffa', country: 'Bahrain', tz: 'Asia/Bahrain' },
    { city: 'Muscat', country: 'Oman', tz: 'Asia/Muscat' },
    { city: 'Salalah', country: 'Oman', tz: 'Asia/Muscat' },
    { city: 'Sanaa', country: 'Yemen', tz: 'Asia/Aden' },
    { city: 'Aden', country: 'Yemen', tz: 'Asia/Aden' },
    { city: 'Tehran', country: 'Iran', tz: 'Asia/Tehran' },
    { city: 'Mashhad', country: 'Iran', tz: 'Asia/Tehran' },
    { city: 'Isfahan', country: 'Iran', tz: 'Asia/Tehran' },
    { city: 'Tabriz', country: 'Iran', tz: 'Asia/Tehran' },
    { city: 'New Delhi', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Delhi', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Mumbai', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Bangalore', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Bengaluru', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Hyderabad', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Chennai', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Kolkata', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Ahmedabad', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Pune', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Surat', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Jaipur', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Lucknow', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Kanpur', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Nagpur', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Indore', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Bhopal', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Vadodara', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Coimbatore', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Chandigarh', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Kochi', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Goa', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Amritsar', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Jodhpur', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Udaipur', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Varanasi', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Islamabad', country: 'Pakistan', tz: 'Asia/Karachi' },
    { city: 'Karachi', country: 'Pakistan', tz: 'Asia/Karachi' },
    { city: 'Lahore', country: 'Pakistan', tz: 'Asia/Karachi' },
    { city: 'Faisalabad', country: 'Pakistan', tz: 'Asia/Karachi' },
    { city: 'Rawalpindi', country: 'Pakistan', tz: 'Asia/Karachi' },
    { city: 'Dhaka', country: 'Bangladesh', tz: 'Asia/Dhaka' },
    { city: 'Chittagong', country: 'Bangladesh', tz: 'Asia/Dhaka' },
    { city: 'Khulna', country: 'Bangladesh', tz: 'Asia/Dhaka' },
    { city: 'Kathmandu', country: 'Nepal', tz: 'Asia/Kathmandu' },
    { city: 'Pokhara', country: 'Nepal', tz: 'Asia/Kathmandu' },
    { city: 'Colombo', country: 'Sri Lanka', tz: 'Asia/Colombo' },
    { city: 'Kandy', country: 'Sri Lanka', tz: 'Asia/Colombo' },
    { city: 'Galle', country: 'Sri Lanka', tz: 'Asia/Colombo' },
    { city: 'Thimphu', country: 'Bhutan', tz: 'Asia/Thimphu' },
    { city: 'Male', country: 'Maldives', tz: 'Indian/Maldives' },
    { city: 'Kabul', country: 'Afghanistan', tz: 'Asia/Kabul' },
    { city: 'Kandahar', country: 'Afghanistan', tz: 'Asia/Kabul' },
    { city: 'Beijing', country: 'China', tz: 'Asia/Shanghai' },
    { city: 'Shanghai', country: 'China', tz: 'Asia/Shanghai' },
    { city: 'Guangzhou', country: 'China', tz: 'Asia/Shanghai' },
    { city: 'Shenzhen', country: 'China', tz: 'Asia/Shanghai' },
    { city: 'Chengdu', country: 'China', tz: 'Asia/Shanghai' },
    { city: 'Tokyo', country: 'Japan', tz: 'Asia/Tokyo' },
    { city: 'Yokohama', country: 'Japan', tz: 'Asia/Tokyo' },
    { city: 'Osaka', country: 'Japan', tz: 'Asia/Tokyo' },
    { city: 'Nagoya', country: 'Japan', tz: 'Asia/Tokyo' },
    { city: 'Seoul', country: 'South Korea', tz: 'Asia/Seoul' },
    { city: 'Busan', country: 'South Korea', tz: 'Asia/Seoul' },
    { city: 'Incheon', country: 'South Korea', tz: 'Asia/Seoul' },
    { city: 'Pyongyang', country: 'North Korea', tz: 'Asia/Pyongyang' },
    { city: 'Taipei', country: 'Taiwan', tz: 'Asia/Taipei' },
    { city: 'Kaohsiung', country: 'Taiwan', tz: 'Asia/Taipei' },
    { city: 'Taichung', country: 'Taiwan', tz: 'Asia/Taipei' },
    { city: 'Hong Kong', country: 'Hong Kong', tz: 'Asia/Hong_Kong' },
    { city: 'Macau', country: 'Macau', tz: 'Asia/Macau' },
    { city: 'Ulaanbaatar', country: 'Mongolia', tz: 'Asia/Ulaanbaatar' },
    { city: 'Hanoi', country: 'Vietnam', tz: 'Asia/Ho_Chi_Minh' },
    { city: 'Ho Chi Minh City', country: 'Vietnam', tz: 'Asia/Ho_Chi_Minh' },
    { city: 'Da Nang', country: 'Vietnam', tz: 'Asia/Ho_Chi_Minh' },
    { city: 'Bangkok', country: 'Thailand', tz: 'Asia/Bangkok' },
    { city: 'Nonthaburi', country: 'Thailand', tz: 'Asia/Bangkok' },
    { city: 'Chiang Mai', country: 'Thailand', tz: 'Asia/Bangkok' },
    { city: 'Singapore', country: 'Singapore', tz: 'Asia/Singapore' },
    { city: 'Kuala Lumpur', country: 'Malaysia', tz: 'Asia/Kuala_Lumpur' },
    { city: 'George Town', country: 'Malaysia', tz: 'Asia/Kuala_Lumpur' },
    { city: 'Johor Bahru', country: 'Malaysia', tz: 'Asia/Kuala_Lumpur' },
    { city: 'Jakarta', country: 'Indonesia', tz: 'Asia/Jakarta' },
    { city: 'Surabaya', country: 'Indonesia', tz: 'Asia/Jakarta' },
    { city: 'Bandung', country: 'Indonesia', tz: 'Asia/Jakarta' },
    { city: 'Medan', country: 'Indonesia', tz: 'Asia/Jakarta' },
    { city: 'Manila', country: 'Philippines', tz: 'Asia/Manila' },
    { city: 'Quezon City', country: 'Philippines', tz: 'Asia/Manila' },
    { city: 'Davao', country: 'Philippines', tz: 'Asia/Manila' },
    { city: 'Phnom Penh', country: 'Cambodia', tz: 'Asia/Phnom_Penh' },
    { city: 'Siem Reap', country: 'Cambodia', tz: 'Asia/Phnom_Penh' },
    { city: 'Vientiane', country: 'Laos', tz: 'Asia/Vientiane' },
    { city: 'Naypyidaw', country: 'Myanmar', tz: 'Asia/Yangon' },
    { city: 'Yangon', country: 'Myanmar', tz: 'Asia/Yangon' },
    { city: 'Mandalay', country: 'Myanmar', tz: 'Asia/Yangon' },
    { city: 'Bandar Seri Begawan', country: 'Brunei', tz: 'Asia/Brunei' },
    { city: 'Dili', country: 'Timor-Leste', tz: 'Asia/Dili' },
    { city: 'Astana', country: 'Kazakhstan', tz: 'Asia/Almaty' },
    { city: 'Almaty', country: 'Kazakhstan', tz: 'Asia/Almaty' },
    { city: 'Shymkent', country: 'Kazakhstan', tz: 'Asia/Almaty' },
    { city: 'Tashkent', country: 'Uzbekistan', tz: 'Asia/Tashkent' },
    { city: 'Samarkand', country: 'Uzbekistan', tz: 'Asia/Tashkent' },
    { city: 'Namangan', country: 'Uzbekistan', tz: 'Asia/Tashkent' },
    { city: 'Bishkek', country: 'Kyrgyzstan', tz: 'Asia/Bishkek' },
    { city: 'Osh', country: 'Kyrgyzstan', tz: 'Asia/Bishkek' },
    { city: 'Dushanbe', country: 'Tajikistan', tz: 'Asia/Dushanbe' },
    { city: 'Ashgabat', country: 'Turkmenistan', tz: 'Asia/Ashgabat' },
    { city: 'Tbilisi', country: 'Georgia', tz: 'Asia/Tbilisi' },
    { city: 'Batumi', country: 'Georgia', tz: 'Asia/Tbilisi' },
    { city: 'Kutaisi', country: 'Georgia', tz: 'Asia/Tbilisi' },
    { city: 'Yerevan', country: 'Armenia', tz: 'Asia/Yerevan' },
    { city: 'Gyumri', country: 'Armenia', tz: 'Asia/Yerevan' },
    { city: 'Baku', country: 'Azerbaijan', tz: 'Asia/Baku' },
    { city: 'Ganja', country: 'Azerbaijan', tz: 'Asia/Baku' },
    { city: 'Cairo', country: 'Egypt', tz: 'Africa/Cairo' },
    { city: 'Alexandria', country: 'Egypt', tz: 'Africa/Cairo' },
    { city: 'Giza', country: 'Egypt', tz: 'Africa/Cairo' },
    { city: 'Rabat', country: 'Morocco', tz: 'Africa/Casablanca' },
    { city: 'Casablanca', country: 'Morocco', tz: 'Africa/Casablanca' },
    { city: 'Marrakesh', country: 'Morocco', tz: 'Africa/Casablanca' },
    { city: 'Fes', country: 'Morocco', tz: 'Africa/Casablanca' },
    { city: 'Algiers', country: 'Algeria', tz: 'Africa/Algiers' },
    { city: 'Oran', country: 'Algeria', tz: 'Africa/Algiers' },
    { city: 'Constantine', country: 'Algeria', tz: 'Africa/Algiers' },
    { city: 'Tunis', country: 'Tunisia', tz: 'Africa/Tunis' },
    { city: 'Sfax', country: 'Tunisia', tz: 'Africa/Tunis' },
    { city: 'Tripoli', country: 'Libya', tz: 'Africa/Tripoli' },
    { city: 'Benghazi', country: 'Libya', tz: 'Africa/Tripoli' },
    { city: 'Khartoum', country: 'Sudan', tz: 'Africa/Khartoum' },
    { city: 'Omdurman', country: 'Sudan', tz: 'Africa/Khartoum' },
    { city: 'Addis Ababa', country: 'Ethiopia', tz: 'Africa/Addis_Ababa' },
    { city: 'Dire Dawa', country: 'Ethiopia', tz: 'Africa/Addis_Ababa' },
    { city: 'Nairobi', country: 'Kenya', tz: 'Africa/Nairobi' },
    { city: 'Mombasa', country: 'Kenya', tz: 'Africa/Nairobi' },
    { city: 'Kisumu', country: 'Kenya', tz: 'Africa/Nairobi' },
    { city: 'Kampala', country: 'Uganda', tz: 'Africa/Kampala' },
    { city: 'Dar es Salaam', country: 'Tanzania', tz: 'Africa/Dar_es_Salaam' },
    { city: 'Dodoma', country: 'Tanzania', tz: 'Africa/Dar_es_Salaam' },
    { city: 'Mwanza', country: 'Tanzania', tz: 'Africa/Dar_es_Salaam' },
    { city: 'Kigali', country: 'Rwanda', tz: 'Africa/Kigali' },
    { city: 'Lagos', country: 'Nigeria', tz: 'Africa/Lagos' },
    { city: 'Abuja', country: 'Nigeria', tz: 'Africa/Lagos' },
    { city: 'Kano', country: 'Nigeria', tz: 'Africa/Lagos' },
    { city: 'Ibadan', country: 'Nigeria', tz: 'Africa/Lagos' },
    { city: 'Accra', country: 'Ghana', tz: 'Africa/Accra' },
    { city: 'Kumasi', country: 'Ghana', tz: 'Africa/Accra' },
    { city: 'Abidjan', country: 'Ivory Coast', tz: 'Africa/Abidjan' },
    { city: 'Yamoussoukro', country: 'Ivory Coast', tz: 'Africa/Abidjan' },
    { city: 'Dakar', country: 'Senegal', tz: 'Africa/Dakar' },
    { city: 'Bamako', country: 'Mali', tz: 'Africa/Bamako' },
    { city: 'Johannesburg', country: 'South Africa', tz: 'Africa/Johannesburg' },
    { city: 'Cape Town', country: 'South Africa', tz: 'Africa/Johannesburg' },
    { city: 'Durban', country: 'South Africa', tz: 'Africa/Johannesburg' },
    { city: 'Pretoria', country: 'South Africa', tz: 'Africa/Johannesburg' },
    { city: 'Harare', country: 'Zimbabwe', tz: 'Africa/Harare' },
    { city: 'Bulawayo', country: 'Zimbabwe', tz: 'Africa/Harare' },
    { city: 'Lusaka', country: 'Zambia', tz: 'Africa/Lusaka' },
    { city: 'Luanda', country: 'Angola', tz: 'Africa/Luanda' },
    { city: 'Maputo', country: 'Mozambique', tz: 'Africa/Maputo' },
    { city: 'Gaborone', country: 'Botswana', tz: 'Africa/Gaborone' },
    { city: 'Windhoek', country: 'Namibia', tz: 'Africa/Windhoek' },
    { city: 'Kinshasa', country: 'DR Congo', tz: 'Africa/Kinshasa' },
    { city: 'Lubumbashi', country: 'DR Congo', tz: 'Africa/Lubumbashi' },
    { city: 'Yaounde', country: 'Cameroon', tz: 'Africa/Douala' },
    { city: 'Douala', country: 'Cameroon', tz: 'Africa/Douala' },
    { city: 'Port Louis', country: 'Mauritius', tz: 'Indian/Mauritius' },
    { city: 'Antananarivo', country: 'Madagascar', tz: 'Indian/Antananarivo' },
    { city: 'Washington DC', country: 'USA', tz: 'America/New_York' },
    { city: 'New York', country: 'USA', tz: 'America/New_York' },
    { city: 'Los Angeles', country: 'USA', tz: 'America/Los_Angeles' },
    { city: 'Chicago', country: 'USA', tz: 'America/Chicago' },
    { city: 'Houston', country: 'USA', tz: 'America/Chicago' },
    { city: 'Phoenix', country: 'USA', tz: 'America/Phoenix' },
    { city: 'Philadelphia', country: 'USA', tz: 'America/New_York' },
    { city: 'San Antonio', country: 'USA', tz: 'America/Chicago' },
    { city: 'San Diego', country: 'USA', tz: 'America/Los_Angeles' },
    { city: 'Dallas', country: 'USA', tz: 'America/Chicago' },
    { city: 'San Francisco', country: 'USA', tz: 'America/Los_Angeles' },
    { city: 'Seattle', country: 'USA', tz: 'America/Los_Angeles' },
    { city: 'Miami', country: 'USA', tz: 'America/New_York' },
    { city: 'Atlanta', country: 'USA', tz: 'America/New_York' },
    { city: 'Boston', country: 'USA', tz: 'America/New_York' },
    { city: 'Denver', country: 'USA', tz: 'America/Denver' },
    { city: 'Ottawa', country: 'Canada', tz: 'America/Toronto' },
    { city: 'Toronto', country: 'Canada', tz: 'America/Toronto' },
    { city: 'Montreal', country: 'Canada', tz: 'America/Toronto' },
    { city: 'Vancouver', country: 'Canada', tz: 'America/Vancouver' },
    { city: 'Calgary', country: 'Canada', tz: 'America/Edmonton' },
    { city: 'Mexico City', country: 'Mexico', tz: 'America/Mexico_City' },
    { city: 'Guadalajara', country: 'Mexico', tz: 'America/Mexico_City' },
    { city: 'Monterrey', country: 'Mexico', tz: 'America/Monterrey' },
    { city: 'Guatemala City', country: 'Guatemala', tz: 'America/Guatemala' },
    { city: 'San Salvador', country: 'El Salvador', tz: 'America/El_Salvador' },
    { city: 'Tegucigalpa', country: 'Honduras', tz: 'America/Tegucigalpa' },
    { city: 'Managua', country: 'Nicaragua', tz: 'America/Managua' },
    { city: 'San Jose', country: 'Costa Rica', tz: 'America/Costa_Rica' },
    { city: 'Panama City', country: 'Panama', tz: 'America/Panama' },
    { city: 'Havana', country: 'Cuba', tz: 'America/Havana' },
    { city: 'Santo Domingo', country: 'Dominican Republic', tz: 'America/Santo_Domingo' },
    { city: 'Kingston', country: 'Jamaica', tz: 'America/Jamaica' },
    { city: 'Port-au-Prince', country: 'Haiti', tz: 'America/Port-au-Prince' },
    { city: 'San Juan', country: 'Puerto Rico', tz: 'America/Puerto_Rico' },
    { city: 'Nassau', country: 'Bahamas', tz: 'America/Nassau' },
    { city: 'Bridgetown', country: 'Barbados', tz: 'America/Barbados' },
    { city: 'Port of Spain', country: 'Trinidad and Tobago', tz: 'America/Port_of_Spain' },
    { city: 'Brasilia', country: 'Brazil', tz: 'America/Sao_Paulo' },
    { city: 'Sao Paulo', country: 'Brazil', tz: 'America/Sao_Paulo' },
    { city: 'Rio de Janeiro', country: 'Brazil', tz: 'America/Sao_Paulo' },
    { city: 'Salvador', country: 'Brazil', tz: 'America/Bahia' },
    { city: 'Buenos Aires', country: 'Argentina', tz: 'America/Argentina/Buenos_Aires' },
    { city: 'Cordoba', country: 'Argentina', tz: 'America/Argentina/Cordoba' },
    { city: 'Rosario', country: 'Argentina', tz: 'America/Argentina/Cordoba' },
    { city: 'Santiago', country: 'Chile', tz: 'America/Santiago' },
    { city: 'Valparaiso', country: 'Chile', tz: 'America/Santiago' },
    { city: 'Concepcion', country: 'Chile', tz: 'America/Santiago' },
    { city: 'Lima', country: 'Peru', tz: 'America/Lima' },
    { city: 'Arequipa', country: 'Peru', tz: 'America/Lima' },
    { city: 'Trujillo', country: 'Peru', tz: 'America/Lima' },
    { city: 'Bogota', country: 'Colombia', tz: 'America/Bogota' },
    { city: 'Medellin', country: 'Colombia', tz: 'America/Bogota' },
    { city: 'Cali', country: 'Colombia', tz: 'America/Bogota' },
    { city: 'Caracas', country: 'Venezuela', tz: 'America/Caracas' },
    { city: 'Maracaibo', country: 'Venezuela', tz: 'America/Caracas' },
    { city: 'Valencia', country: 'Venezuela', tz: 'America/Caracas' },
    { city: 'Quito', country: 'Ecuador', tz: 'America/Guayaquil' },
    { city: 'Guayaquil', country: 'Ecuador', tz: 'America/Guayaquil' },
    { city: 'La Paz', country: 'Bolivia', tz: 'America/La_Paz' },
    { city: 'Santa Cruz', country: 'Bolivia', tz: 'America/La_Paz' },
    { city: 'Sucre', country: 'Bolivia', tz: 'America/La_Paz' },
    { city: 'Asuncion', country: 'Paraguay', tz: 'America/Asuncion' },
    { city: 'Montevideo', country: 'Uruguay', tz: 'America/Montevideo' },
    { city: 'Georgetown', country: 'Guyana', tz: 'America/Guyana' },
    { city: 'Paramaribo', country: 'Suriname', tz: 'America/Paramaribo' },
    { city: 'Canberra', country: 'Australia', tz: 'Australia/Sydney' },
    { city: 'Sydney', country: 'Australia', tz: 'Australia/Sydney' },
    { city: 'Melbourne', country: 'Australia', tz: 'Australia/Melbourne' },
    { city: 'Brisbane', country: 'Australia', tz: 'Australia/Brisbane' },
    { city: 'Perth', country: 'Australia', tz: 'Australia/Perth' },
    { city: 'Adelaide', country: 'Australia', tz: 'Australia/Adelaide' },
    { city: 'Wellington', country: 'New Zealand', tz: 'Pacific/Auckland' },
    { city: 'Auckland', country: 'New Zealand', tz: 'Pacific/Auckland' },
    { city: 'Christchurch', country: 'New Zealand', tz: 'Pacific/Auckland' },
    { city: 'Port Moresby', country: 'Papua New Guinea', tz: 'Pacific/Port_Moresby' },
    { city: 'Suva', country: 'Fiji', tz: 'Pacific/Fiji' },
    { city: 'Noumea', country: 'New Caledonia', tz: 'Pacific/Noumea' },
    { city: 'Apia', country: 'Samoa', tz: 'Pacific/Apia' },
    { city: 'Port Vila', country: 'Vanuatu', tz: 'Pacific/Efate' },
    { city: 'Honiara', country: 'Solomon Islands', tz: 'Pacific/Guadalcanal' },
    { city: 'Agra', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Meerut', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Allahabad', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Prayagraj', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Ghaziabad', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Noida', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Gurgaon', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Gurugram', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Faridabad', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Patna', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Gaya', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Ranchi', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Jamshedpur', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Dhanbad', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Bhubaneswar', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Cuttack', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Raipur', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Jabalpur', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Gwalior', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Ujjain', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Rajkot', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Bhavnagar', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Jamnagar', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Gandhinagar', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Anand', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Nadiad', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Bhuj', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Junagadh', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Porbandar', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Nashik', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Aurangabad', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Solapur', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Kolhapur', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Sangli', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Nanded', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Amravati', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Akola', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Thane', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Navi Mumbai', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Kalyan', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Vasai', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Mysore', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Mysuru', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Mangalore', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Mangaluru', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Hubli', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Belgaum', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Belagavi', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Gulbarga', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Davangere', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Bellary', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Madurai', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Tiruchirappalli', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Trichy', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Salem', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Tirunelveli', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Erode', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Vellore', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Thanjavur', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Tirupati', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Vijayawada', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Visakhapatnam', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Vizag', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Guntur', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Nellore', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Warangal', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Nizamabad', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Karimnagar', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Thiruvananthapuram', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Trivandrum', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Kozhikode', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Calicut', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Thrissur', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Kollam', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Kannur', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Alappuzha', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Kottayam', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Palakkad', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Guwahati', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Shillong', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Imphal', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Agartala', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Aizawl', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Kohima', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Itanagar', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Gangtok', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Dispur', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Silchar', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Dehradun', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Haridwar', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Rishikesh', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Nainital', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Shimla', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Dharamshala', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Jammu', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Srinagar', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Ludhiana', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Jalandhar', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Patiala', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Bathinda', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Mohali', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Panchkula', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Ambala', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Karnal', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Panipat', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Hisar', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Rohtak', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Sonipat', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Ajmer', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Kota', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Bikaner', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Alwar', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Bharatpur', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Sikar', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Pali', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Bareilly', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Moradabad', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Aligarh', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Mathura', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Firozabad', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Saharanpur', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Gorakhpur', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Jhansi', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Durgapur', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Asansol', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Siliguri', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Howrah', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Pondicherry', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Puducherry', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Panaji', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Margao', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Vapi', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Valsad', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Navsari', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Mehsana', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Morbi', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Veraval', country: 'India', tz: 'Asia/Kolkata' },
    { city: 'Nakuru', country: 'Kenya', tz: 'Africa/Nairobi' },
    { city: 'Eldoret', country: 'Kenya', tz: 'Africa/Nairobi' },
    { city: 'Thika', country: 'Kenya', tz: 'Africa/Nairobi' },
    { city: 'Jinja', country: 'Uganda', tz: 'Africa/Kampala' },
    { city: 'Entebbe', country: 'Uganda', tz: 'Africa/Kampala' },
    { city: 'Mbarara', country: 'Uganda', tz: 'Africa/Kampala' },
    { city: 'Tororo', country: 'Uganda', tz: 'Africa/Kampala' },
    { city: 'Arusha', country: 'Tanzania', tz: 'Africa/Dar_es_Salaam' },
    { city: 'Tanga', country: 'Tanzania', tz: 'Africa/Dar_es_Salaam' },
    { city: 'Zanzibar', country: 'Tanzania', tz: 'Africa/Dar_es_Salaam' },
    { city: 'Morogoro', country: 'Tanzania', tz: 'Africa/Dar_es_Salaam' },
    { city: 'Moshi', country: 'Tanzania', tz: 'Africa/Dar_es_Salaam' },
    { city: 'Bujumbura', country: 'Burundi', tz: 'Africa/Bujumbura' },
    { city: 'Kitwe', country: 'Zambia', tz: 'Africa/Lusaka' },
    { city: 'Ndola', country: 'Zambia', tz: 'Africa/Lusaka' },
    { city: 'Lilongwe', country: 'Malawi', tz: 'Africa/Blantyre' },
    { city: 'Blantyre', country: 'Malawi', tz: 'Africa/Blantyre' },
    { city: 'Limbe', country: 'Malawi', tz: 'Africa/Blantyre' },
    { city: 'Gweru', country: 'Zimbabwe', tz: 'Africa/Harare' },
    { city: 'Pietermaritzburg', country: 'South Africa', tz: 'Africa/Johannesburg' },
    { city: 'Port Elizabeth', country: 'South Africa', tz: 'Africa/Johannesburg' },
    { city: 'Lenasia', country: 'South Africa', tz: 'Africa/Johannesburg' },
    { city: 'Verulam', country: 'South Africa', tz: 'Africa/Johannesburg' },
    { city: 'Tongaat', country: 'South Africa', tz: 'Africa/Johannesburg' },
    { city: 'Chatsworth', country: 'South Africa', tz: 'Africa/Johannesburg' },
    { city: 'Francistown', country: 'Botswana', tz: 'Africa/Gaborone' },
    { city: 'Beira', country: 'Mozambique', tz: 'Africa/Maputo' },
    { city: 'Nampula', country: 'Mozambique', tz: 'Africa/Maputo' },
    { city: 'Beau Bassin', country: 'Mauritius', tz: 'Indian/Mauritius' },
    { city: 'Vacoas', country: 'Mauritius', tz: 'Indian/Mauritius' },
    { city: 'Curepipe', country: 'Mauritius', tz: 'Indian/Mauritius' },
    { city: 'Quatre Bornes', country: 'Mauritius', tz: 'Indian/Mauritius' },
    { city: 'Rose Hill', country: 'Mauritius', tz: 'Indian/Mauritius' },
    { city: 'Toamasina', country: 'Madagascar', tz: 'Indian/Antananarivo' },
    { city: 'Victoria', country: 'Seychelles', tz: 'Indian/Mahe' },
    { city: 'Lome', country: 'Togo', tz: 'Africa/Lome' },
    { city: 'Moroni', country: 'Comoros', tz: 'Indian/Comoro' }
  ];

  const RASHIS = [
    { name: 'Mesha', en: 'Aries', skt: 'मेष', lord: 'Mangal (Mars)', elem: 'Fire (Agni)', guna: 'Rajasic' },
    { name: 'Vrishabha', en: 'Taurus', skt: 'वृषभ', lord: 'Shukra (Venus)', elem: 'Earth (Prithvi)', guna: 'Tamasic' },
    { name: 'Mithuna', en: 'Gemini', skt: 'मिथुन', lord: 'Budha (Mercury)', elem: 'Air (Vayu)', guna: 'Rajasic' },
    { name: 'Karka', en: 'Cancer', skt: 'कर्क', lord: 'Chandra (Moon)', elem: 'Water (Jal)', guna: 'Sattvic' },
    { name: 'Simha', en: 'Leo', skt: 'सिंह', lord: 'Surya (Sun)', elem: 'Fire (Agni)', guna: 'Sattvic' },
    { name: 'Kanya', en: 'Virgo', skt: 'कन्या', lord: 'Budha (Mercury)', elem: 'Earth (Prithvi)', guna: 'Tamasic' },
    { name: 'Tula', en: 'Libra', skt: 'तुला', lord: 'Shukra (Venus)', elem: 'Air (Vayu)', guna: 'Rajasic' },
    { name: 'Vrischika', en: 'Scorpio', skt: 'वृश्चिक', lord: 'Mangal (Mars)', elem: 'Water (Jal)', guna: 'Sattvic' },
    { name: 'Dhanu', en: 'Sagittarius', skt: 'धनु', lord: 'Guru (Jupiter)', elem: 'Fire (Agni)', guna: 'Sattvic' },
    { name: 'Makara', en: 'Capricorn', skt: 'मकर', lord: 'Shani (Saturn)', elem: 'Earth (Prithvi)', guna: 'Tamasic' },
    { name: 'Kumbha', en: 'Aquarius', skt: 'कुम्भ', lord: 'Shani (Saturn)', elem: 'Air (Vayu)', guna: 'Rajasic' },
    { name: 'Meena', en: 'Pisces', skt: 'मीन', lord: 'Guru (Jupiter)', elem: 'Water (Jal)', guna: 'Sattvic' }
  ];
  const NAKSHATRAS = ['Ashwini','Bharani','Krittika','Rohini','Mrigashira','Ardra','Punarvasu','Pushya','Ashlesha','Magha','Purva Phalguni','Uttara Phalguni','Hasta','Chitra','Swati','Vishakha','Anuradha','Jyeshtha','Mula','Purva Ashadha','Uttara Ashadha','Shravana','Dhanishtha','Shatabhisha','Purva Bhadrapada','Uttara Bhadrapada','Revati'];

  function toJD(dateStr, timeStr, tz) {
    const fmt = new Intl.DateTimeFormat('en-CA', { timeZone: tz, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false });
    const localDT = new Date(`${dateStr}T${timeStr || '00:00'}:00`);
    const parts = fmt.formatToParts(localDT);
    const get = t => parseInt(parts.find(p => p.type === t).value);
    const Y = get('year'), M = get('month'), D = get('day');
    const h = get('hour'), m = get('minute'), s = get('second');
    const A = Math.floor((14 - M) / 12);
    const y = Y + 4800 - A;
    const mo = M + 12 * A - 3;
    let jd = D + Math.floor((153 * mo + 2) / 5) + 365 * y + Math.floor(y / 4) - Math.floor(y / 100) + Math.floor(y / 400) - 32045;
    jd += (h - 12) / 24 + m / 1440 + s / 86400;
    return jd;
  }

  function moonLongitude(jd) {
    const T = (jd - 2451545.0) / 36525;
    const r = Math.PI / 180;
    let L  = 218.3164477 + 481267.88123421*T - 0.0015786*T*T + T*T*T/538841 - T*T*T*T/65194000;
    let M  = 357.5291092 + 35999.0502909*T   - 0.0001536*T*T + T*T*T/24490000;
    let Mp = 134.9633964 + 477198.8675055*T  + 0.0087414*T*T + T*T*T/69699 - T*T*T*T/14712000;
    let D  = 297.8501921 + 445267.1114034*T  - 0.0018819*T*T + T*T*T/545868 - T*T*T*T/113065000;
    let F  = 93.2720950  + 483202.0175233*T  - 0.0036539*T*T - T*T*T/3526000 + T*T*T*T/863310000;
    M*=r; Mp*=r; D*=r; F*=r;
    const E = 1 - 0.002516*T - 0.0000074*T*T;
    const sum =
       6.288774*Math.sin(Mp) + 1.274027*Math.sin(2*D-Mp) + 0.658314*Math.sin(2*D) + 0.213618*Math.sin(2*Mp)
     - 0.185116*E*Math.sin(M) - 0.114332*Math.sin(2*F) + 0.058793*Math.sin(2*D-2*Mp) + 0.057066*E*Math.sin(2*D-M-Mp)
     + 0.053322*Math.sin(2*D+Mp) + 0.045758*E*Math.sin(2*D-M) - 0.040923*E*Math.sin(M-Mp) - 0.034720*Math.sin(D)
     - 0.030383*E*Math.sin(M+Mp) + 0.015327*Math.sin(2*D-2*F) - 0.012528*Math.sin(Mp+2*F) + 0.010980*Math.sin(Mp-2*F)
     + 0.010675*Math.sin(4*D-Mp) + 0.010034*Math.sin(3*Mp) + 0.008548*Math.sin(4*D-2*Mp) - 0.007888*E*Math.sin(2*D+M-Mp)
     - 0.006766*E*Math.sin(2*D+M) - 0.005163*Math.sin(D-Mp);
    const ayanamsha = 23.85 + 0.0001396*(jd-2451545)/365.25;
    return (((L+sum)-ayanamsha) % 360 + 360) % 360;
  }

  const RASHI_PRODUCTS = {
    0:  { stone:'Garnet', why:'Mangal rules Mesha. Garnet carries the red fire of Mars — grounding, energising, and protective.', products:[{name:'Agniti Necklace',gem:'Garnet',price:'£89',url:'https://www.nimmisha.com/products/agniti-necklace'},{name:'Agira Ring',gem:'Garnet',price:'£84',url:'https://www.nimmisha.com/products/agira-ring'}] },
    1:  { stone:'White Topaz', why:'Shukra rules Vrishabha. White Topaz channels Venus energy — clarity, beauty, and material grace.', products:[{name:'Reya Ring',gem:'White Topaz',price:'£179',url:'https://www.nimmisha.com/products/reya-ring'},{name:'Antara Necklace',gem:'White Topaz',price:'£169',url:'https://www.nimmisha.com/products/antara-necklace'}] },
    2:  { stone:'Malachite', why:"Budha rules Mithuna. Malachite carries Mercury's green energy — curiosity, communication, and adaptability.", products:[{name:'Vanya Ring',gem:'Malachite',price:'£69',url:'https://www.nimmisha.com/products/vanya'},{name:'Tarang Necklace',gem:'Malachite',price:'£129',url:'https://www.nimmisha.com/products/tarang-necklace'}] },
    3:  { stone:'Pearl', why:"Chandra rules Karka. Pearl is the Moon's own stone — nurturing, intuitive, and emotionally restorative.", products:[{name:'Niyam Ring',gem:'Pearl',price:'£99',url:'https://www.nimmisha.com/products/niyam-ring'},{name:'Navya Necklace',gem:'Pearl',price:'£80',url:'https://www.nimmisha.com/products/navya-necklace'}] },
    4:  { stone:'Garnet', why:'Surya rules Simha. Garnet channels solar fire — confidence, vitality, and sovereign presence.', products:[{name:'Agniti Necklace',gem:'Garnet',price:'£89',url:'https://www.nimmisha.com/products/agniti-necklace'},{name:'Agira Ring',gem:'Garnet',price:'£84',url:'https://www.nimmisha.com/products/agira-ring'}] },
    5:  { stone:'Malachite', why:'Budha rules Kanya. Malachite aligns with Mercury\'s precise energy — clarity in thought, precision in action.', products:[{name:'Vanya Ring',gem:'Malachite',price:'£69',url:'https://www.nimmisha.com/products/vanya'},{name:'Mann Bracelet',gem:'Malachite',price:'£84',url:'https://www.nimmisha.com/products/mann-the-heart-mind-strength-lives-where-softness-listens'}] },
    6:  { stone:'White Topaz', why:'Shukra rules Tula. White Topaz embodies Venusian balance — harmony, aesthetic refinement, and relational ease.', products:[{name:'Sahaya Ring',gem:'White Topaz',price:'£139',url:'https://www.nimmisha.com/products/sahaya-ring'},{name:'Noura Cuff',gem:'White Topaz',price:'£198',url:'https://www.nimmisha.com/products/noura-cuff'}] },
    7:  { stone:'Garnet', why:'Mangal rules Vrischika. Garnet holds Martian depth — transformation, intensity, and regenerative power.', products:[{name:'Agira Ring',gem:'Garnet',price:'£84',url:'https://www.nimmisha.com/products/agira-ring'},{name:'Agniti Necklace',gem:'Garnet',price:'£89',url:'https://www.nimmisha.com/products/agniti-necklace'}] },
    8:  { stone:'Citrine', why:"Guru rules Dhanu. Citrine carries Jupiter's expansive warmth — optimism, wisdom, and abundance.", products:[{name:'Triya Earrings',gem:'Citrine & Malachite',price:'£79',url:'https://www.nimmisha.com/products/triya-three-stones-one-grounded-radiance'},{name:'Aarka Earrings',gem:'Blue Topaz',price:'£105',url:'https://www.nimmisha.com/products/aarka-illuminate-inward-lead-outward'}] },
    9:  { stone:'Lapis Lazuli', why:"Shani rules Makara. Lapis Lazuli carries Saturn's deep authority — discipline, truth, and enduring focus.", products:[{name:'Kosha Necklace',gem:'Lapis Lazuli',price:'£119',url:'https://www.nimmisha.com/products/kosha'},{name:'Orya Necklace',gem:'Blue Topaz',price:'£89',url:'https://www.nimmisha.com/products/orya-necklace'}] },
    10: { stone:'Amethyst', why:"Shani rules Kumbha. Amethyst holds Saturn's meditative depth — clarity of purpose and spiritual awareness.", products:[{name:'Pancha Ring',gem:'Amethyst',price:'£98',url:'https://www.nimmisha.com/products/pancha-ring'},{name:'Aarka Earrings',gem:'Blue Topaz',price:'£105',url:'https://www.nimmisha.com/products/aarka-illuminate-inward-lead-outward'}] },
    11: { stone:'Pearl & Moonstone', why:"Guru rules Meena. Pearl and Moonstone carry Jupiter's compassion — intuition, spiritual depth, and boundless empathy.", products:[{name:'Lunara Earrings',gem:'Moonstone',price:'£189',url:'https://www.nimmisha.com/products/lunara-command-the-quiet-illuminate-without-apology'},{name:'Deepa Ring',gem:'Pearl',price:'£89',url:'https://www.nimmisha.com/products/deepa-ring'}] }
  };

  /* ── DOM helpers ── */
  function $(id) { return document.getElementById(id); }
  function slug(s) {
    return (s || '').toLowerCase().replace(/&/g, ' ').trim().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }
  function stoneImg(name) {
    var st = (window.RASHI_ICONS && window.RASHI_ICONS.stones) || {};
    var s = slug(name);
    if (st[s]) return st[s];
    var first = s.split('-')[0];
    return st[first] || '';
  }
  function handleFromUrl(u) {
    var m = (u || '').match(/\/products\/([^/?#]+)/);
    return m ? m[1] : '';
  }
  function planetKey(lord) { var m = (lord || '').match(/\(([^)]+)\)/); return m ? m[1].trim() : (lord || '').split(' ')[0]; }
  function elemKey(elem) { return (elem || '').split(' ')[0].replace(/[^A-Za-z]/g, ''); }
  function iconInto(id, url, cls, alt) { var el = $(id); if (!el) return; el.innerHTML = url ? '<img class="' + cls + '" src="' + url + '" alt="' + (alt || '') + '" loading="lazy">' : ''; }

  // Charm pendant por Rashi (mismo orden que RASHIS 0..11) — para el enlace del banner
  var RASHI_CHARMS = [
    '/products/aries-charm-pendant',
    '/products/taurus-vrishabha-%E0%A4%B5%E0%A5%83%E0%A4%B7%E0%A4%AD',
    '/products/gemini-charm-pendant',
    '/products/cancer-charm-pendant',
    '/products/leo-charm-pendant',
    '/products/virgo-charm-pendant',
    '/products/libra-charm-pendant',
    '/products/scorpio-charm-pendant',
    '/products/sagittarius-charm-pendant',
    '/products/capricorn-charm-pendant',
    '/products/aquarius-charm-pendant',
    '/products/pisces-charm-pendant'
  ];

  /* ── Imágenes reales de producto (fetch a Shopify) ── */
  var imgCache = {};
  function fetchProductImage(handle) {
    if (!handle) return Promise.resolve(null);
    if (handle in imgCache) return Promise.resolve(imgCache[handle]);
    return fetch('/products/' + handle + '.js')
      .then(function (res) { if (!res.ok) { imgCache[handle] = null; return null; } return res.json(); })
      .then(function (data) { var img = data && data.featured_image ? data.featured_image : null; imgCache[handle] = img; return img; })
      .catch(function () { imgCache[handle] = null; return null; });
  }

  /* ── City autocomplete ── */
  var cityInput, cityDropdown, cityTzHidden, activeIdx = -1;
  function renderDropdown(matches) {
    if (!matches.length) {
      cityDropdown.innerHTML = '<p class="city-none">No results — try a different city name</p>';
    } else {
      cityDropdown.innerHTML = matches.map(function (c, i) {
        return '<div class="city-option" data-tz="' + c.tz + '" data-name="' + c.city + '" data-idx="' + i + '">' +
          c.city + '<div class="city-sub">' + c.country + ' &nbsp;·&nbsp; ' + c.tz.replace('_', ' ') + '</div></div>';
      }).join('');
      cityDropdown.querySelectorAll('.city-option').forEach(function (el) {
        el.addEventListener('mousedown', function (e) { e.preventDefault(); selectCity(el.getAttribute('data-name'), el.getAttribute('data-tz')); });
      });
    }
    cityDropdown.classList.add('open');
    activeIdx = -1;
  }
  function selectCity(name, tz) {
    cityInput.value = name; cityTzHidden.value = tz;
    cityDropdown.classList.remove('open'); cityDropdown.innerHTML = '';
  }

  /* ── Recomendaciones (piedra + productos reales) ── */
  function renderRecos(rashiIdx) {
    var data = RASHI_PRODUCTS[rashiIdx];
    if (!data) return;
    $('rashi-reco-title').textContent = 'Your stone: ' + data.stone;
    $('rashi-reco-subtitle').textContent = data.why;

    var sw = $('rashi-stone-img-wrap');
    var simg = stoneImg(data.stone);
    sw.innerHTML = simg ? '<img class="reco-stone-img" src="' + simg + '" alt="' + data.stone + '" loading="lazy">' : '';

    var grid = $('rashi-product-grid');
    grid.innerHTML = data.products.map(function (p) {
      return '<a class="product-card" href="' + p.url + '" target="_blank" rel="noopener">' +
        '<div class="product-card-img-wrap" data-handle="' + handleFromUrl(p.url) + '">' +
          '<div class="product-image-placeholder"></div>' +
        '</div>' +
        '<div class="product-card-body">' +
          '<p class="product-gem">' + p.gem + '</p>' +
          '<p class="product-card-name">' + p.name + '</p>' +
          '<p class="product-price">' + p.price + '</p>' +
        '</div></a>';
    }).join('');
    grid.querySelectorAll('.product-card-img-wrap').forEach(function (w) {
      var h = w.getAttribute('data-handle');
      if (!h) return;
      fetchProductImage(h).then(function (src) {
        if (src) w.innerHTML = '<img class="product-card-img" src="' + src + '" alt="" loading="lazy">';
      });
    });
    $('rashi-reco-section').style.display = 'block';
  }

  /* ── Cálculo → resultado (sin email gate; resultado libre) ── */
  var pendingResult = null;
  function calcRashi() {
    var dateStr = $('rashi-bdate').value;
    var timeStr = $('rashi-btime').value;
    var tz = $('rashi-city-tz').value;
    var errEl = $('rashi-err');
    if (!dateStr || !timeStr || !tz) {
      errEl.style.display = 'block';
      $('rashi-result').style.display = 'none';
      return;
    }
    errEl.style.display = 'none';
    var jd = toJD(dateStr, timeStr, tz);
    var moonLon = moonLongitude(jd);
    var rashiIdx = Math.floor(moonLon / 30);
    var nakIdx = Math.floor(moonLon / (360 / 27));
    var nakPada = Math.floor((moonLon % (360 / 27)) / (360 / 108)) + 1;
    pendingResult = { rashiIdx: rashiIdx, moonLon: moonLon, nakIdx: nakIdx, nakPada: nakPada };
    revealResult();
  }
  function revealResult() {
    if (!pendingResult) return;
    var rashiIdx = pendingResult.rashiIdx, moonLon = pendingResult.moonLon,
        nakIdx = pendingResult.nakIdx, nakPada = pendingResult.nakPada;
    var r = RASHIS[rashiIdx];
    $('rashi-r-name').textContent = r.name + ' (' + r.en + ')';
    $('rashi-r-skt').textContent = r.skt;
    $('rashi-r-lord-line').textContent = 'Ruled by ' + r.lord;
    $('rashi-r-lon').textContent = moonLon.toFixed(2) + '°';
    $('rashi-r-nak').textContent = NAKSHATRAS[nakIdx];
    $('rashi-r-pada').textContent = 'Pada ' + nakPada;
    $('rashi-r-elem').textContent = r.elem;
    $('rashi-r-guna').textContent = r.guna;
    $('rashi-r-lord').textContent = r.lord;
    // Iconos (set "Untitled design (6)"): signo grande + Luna/Elemento/Planeta en sus casillas
    var ic = window.RASHI_ICONS || {};
    iconInto('rashi-sign-icon', ic.signs && ic.signs[rashiIdx], 'rashi-sign-img', r.en);
    iconInto('rashi-ic-lon', ic.planets && ic.planets['Moon'], '', '');
    iconInto('rashi-ic-elem', ic.elements && ic.elements[elemKey(r.elem)], '', '');
    iconInto('rashi-ic-lord', ic.planets && ic.planets[planetKey(r.lord)], '', '');
    // Enlace del banner → charm del signo del resultado
    var charmCta = $('rashi-banner-cta');
    if (charmCta && RASHI_CHARMS[rashiIdx]) charmCta.setAttribute('href', RASHI_CHARMS[rashiIdx]);
    // Imagen del banner → la del signo del resultado (fade-in; ya precargada al abrir)
    var bannerImg = $('rashi-banner-img');
    if (bannerImg && ic.banners && ic.banners[rashiIdx]) {
      var burl = ic.banners[rashiIdx];
      var revealImg = function () { bannerImg.style.opacity = '1'; };
      if (bannerImg.src !== burl) {
        bannerImg.style.opacity = '0';
        bannerImg.onload = revealImg;
        bannerImg.onerror = revealImg;
        bannerImg.src = burl;
      }
      if (bannerImg.complete) revealImg();
    }
    var res = $('rashi-result');
    res.style.display = 'block';
    renderRecos(rashiIdx);
    setTimeout(function () { res.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 50);
  }

  /* ── Newsletter (opt-in explícito RGPD → Klaviyo) ── */
  function submitNewsletter() {
    var emailInput = $('rashi-nl-email');
    var consent = $('rashi-nl-consent');
    var errEl = $('rashi-nl-error');
    var btn = $('rashi-nl-submit');
    var email = emailInput.value.trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      errEl.textContent = 'Please enter a valid email address.';
      errEl.style.display = 'block';
      return;
    }
    if (!consent.checked) {
      errEl.textContent = 'Please tick the box to confirm you would like to receive our newsletter.';
      errEl.style.display = 'block';
      return;
    }
    errEl.style.display = 'none';
    btn.disabled = true; btn.textContent = 'One moment…';
    var r = pendingResult ? RASHIS[pendingResult.rashiIdx] : null;
    var done = function () { $('rashi-nl-form').style.display = 'none'; $('rashi-nl-success').style.display = 'block'; };
    if (KLAVIYO_ENABLED) {
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + KLAVIYO_PUBLIC_KEY, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
        body: JSON.stringify({ data: { type: 'subscription', attributes: {
          custom_source: 'Vedic Rashi Calculator',
          profile: { data: { type: 'profile', attributes: { email: email, properties: {
            rashi: r ? (r.name + ' (' + r.en + ')') : '',
            rashi_nakshatra: (r && pendingResult) ? NAKSHATRAS[pendingResult.nakIdx] : '',
            rashi_planet: r ? r.lord : '',
            newsletter_consent: true,
            consent_timestamp: new Date().toISOString()
          } } } }
        }, relationships: { list: { data: { type: 'list', id: KLAVIYO_LIST_ID } } } } })
      }).catch(function (e) { console.warn('Klaviyo subscribe failed:', e); }).then(done);
    } else {
      console.info('[Rashi] Klaviyo OFF (pruebas). Se habría enviado:', email, r && r.name);
      done();
    }
  }

  /* ── Modal abrir/cerrar ── */
  var modal;
  // Precarga las 12 imágenes del banner al abrir el calculador, mientras el usuario
  // rellena el formulario → al revelar el resultado la imagen ya está en caché (instantánea).
  var bannersPrefetched = false;
  function prefetchBanners() {
    if (bannersPrefetched) return;
    bannersPrefetched = true;
    var b = (window.RASHI_ICONS || {}).banners || [];
    b.forEach(function (u) { if (u) { var im = new Image(); im.decoding = 'async'; im.src = u; } });
  }
  function openModal() { if (!modal) return; modal.classList.add('is-open'); modal.setAttribute('aria-hidden', 'false'); document.body.classList.add('rashi-calc-lock'); prefetchBanners(); }
  function closeModal() { if (!modal) return; modal.classList.remove('is-open'); modal.setAttribute('aria-hidden', 'true'); document.body.classList.remove('rashi-calc-lock'); }

  /* ── Init ── */
  function init() {
    modal = $('rashiCalcModal');
    document.querySelectorAll('[data-rashi-open]').forEach(function (b) { b.addEventListener('click', openModal); });
    document.querySelectorAll('[data-rashi-close]').forEach(function (b) { b.addEventListener('click', closeModal); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeModal(); });

    var cb = $('rashi-calc-btn'); if (cb) cb.addEventListener('click', calcRashi);
    var nb = $('rashi-nl-submit'); if (nb) nb.addEventListener('click', submitNewsletter);

    cityInput = $('rashi-city-input');
    cityDropdown = $('rashi-city-dropdown');
    cityTzHidden = $('rashi-city-tz');
    if (cityInput && cityDropdown) {
      cityInput.addEventListener('input', function () {
        var q = cityInput.value.trim().toLowerCase();
        cityTzHidden.value = '';
        if (q.length < 2) { cityDropdown.classList.remove('open'); return; }
        var matches = CITIES.filter(function (c) {
          return c.city.toLowerCase().indexOf(q) === 0 || c.city.toLowerCase().indexOf(q) !== -1;
        }).slice(0, 8);
        renderDropdown(matches);
      });
      cityInput.addEventListener('keydown', function (e) {
        var opts = cityDropdown.querySelectorAll('.city-option');
        if (e.key === 'ArrowDown') { e.preventDefault(); activeIdx = Math.min(activeIdx + 1, opts.length - 1); }
        else if (e.key === 'ArrowUp') { e.preventDefault(); activeIdx = Math.max(activeIdx - 1, 0); }
        else if (e.key === 'Enter' && activeIdx >= 0) { e.preventDefault(); var el = opts[activeIdx]; selectCity(el.getAttribute('data-name'), el.getAttribute('data-tz')); return; }
        else if (e.key === 'Escape') { cityDropdown.classList.remove('open'); return; }
        opts.forEach(function (el, i) { el.classList.toggle('active', i === activeIdx); });
      });
      document.addEventListener('click', function (e) { if (!e.target.closest('.city-wrap')) cityDropdown.classList.remove('open'); });
    }
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);

})();
